import * as React from "react";
import { singleton } from "logic/singleton";
export const initialState = {
  backendId: void 0,
  backendGroupSyncIsActive: false,
  licenseIsValid: false,
  setContextValue: () => {
  }
};
const OidcBackendMetaContext = React.createContext(initialState);
export default singleton("contexts.authentication.enterprise.oidc.backendMeta", () => OidcBackendMetaContext);
